

var _autobillingTerms = require('./autobillingTerms');

var _autobillingTerms2 = _interopRequireDefault(_autobillingTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getItemOptions: _autobillingTerms2['default'].getItemOptions,
    getItemName: _autobillingTerms2['default'].getItemName,
    getTermsText: _autobillingTerms2['default'].getTermsText
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/autobilling-terms/index.js
// module id = ../node_modules/xo-page-components/src/autobilling-terms/index.js
// module chunks = 0